module.exports = __webpack_public_path__ + "img/planta_02.dcb052ae.jpg";